<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="12" md="8" lg="6">
      <v-stepper v-model="step" vertical>
        <v-stepper-step
          :complete="step > 1"
          step="1"
          :rules="[() => this.valid]"
          >Provide Details</v-stepper-step
        >

        <v-stepper-content step="1">
          <v-card class="elevation-0">
            <v-card-text>
              <v-form
                @submit.prevent="1"
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-combobox
                  v-model="stone.customer"
                  label="Customer"
                  name="customer"
                  prepend-icon="mdi-account"
                  :items="customers"
                  :rules="[v => !!v || 'Customer is required']"
                  required
                />

                <v-text-field
                  v-model="stone.weight"
                  label="Weight (carats)"
                  name="weight"
                  prepend-icon="mdi-weight"
                  type="number"
                  :rules="[v => !!v || 'Weight is required']"
                  required
                />

                <v-combobox
                  v-model="stone.colour"
                  label="Colour"
                  name="colour"
                  prepend-icon="palette"
                  :items="stoneColours"
                  item-text="name"
                  :rules="[v => !!v || 'Colour is required']"
                  required
                ></v-combobox>

                <v-combobox
                  v-model="stone.shape"
                  label="Shape"
                  name="shape"
                  prepend-icon="mdi-shape"
                  :items="stoneShapes"
                  :rules="[v => !!v || 'Shape is required']"
                  required
                ></v-combobox>

                <v-text-field
                  v-model="stone.width"
                  label="Width (mm)"
                  name="width"
                  prepend-icon="mdi-arrow-expand-horizontal"
                  :rules="[
                    v => !!v || 'Width is required',
                    v =>
                      !!v.match(/^\d+\.\d{2}(?: ?x ?\d+\.\d{2})?$/) ||
                      'Requires format N.NN or N.NNxN.NN'
                  ]"
                  required
                />

                <v-text-field
                  v-model="stone.depth"
                  label="Depth (mm)"
                  name="depth"
                  prepend-icon="mdi-arrow-expand-vertical"
                  type="number"
                  :rules="[v => !!v || 'Depth is required']"
                  required
                />

                <v-text-field
                  v-model="stone.inscription"
                  label="Inscription"
                  name="inscription"
                  prepend-icon="mdi-pencil-outline"
                  type="text"
                />

                <v-text-field
                  v-model="stone.remarks"
                  label="Remarks"
                  name="remarks"
                  prepend-icon="mdi-comment-text-outline"
                  type="text"
                />

                <br />

                <v-file-input
                  v-model="stone.imageNatural"
                  label="Image of Stone"
                  @change="onFileInput($event, 'Natural')"
                  prepend-icon="mdi-camera"
                  :rules="[v => !!v || 'File is required']"
                  show-size
                  required
                  outlined
                  dense
                ></v-file-input>
                <v-file-input
                  v-model="stone.image365"
                  label="365nm Image"
                  @change="onFileInput($event, '365')"
                  prepend-icon="mdi-camera"
                  :rules="[v => !!v || 'File is required']"
                  show-size
                  required
                  outlined
                  dense
                ></v-file-input>
                <v-file-input
                  v-model="stone.image255"
                  label="255nm Image"
                  @change="onFileInput($event, '255')"
                  prepend-icon="mdi-camera"
                  :rules="[v => !!v || 'File is required']"
                  show-size
                  required
                  outlined
                  dense
                ></v-file-input>

                <v-file-input
                  v-model="stone.ftirData"
                  label="FTIR Data (.csv)"
                  outlined
                  dense
                  :rules="[v => !!v || 'File is required']"
                  required
                ></v-file-input>
                <v-file-input
                  v-model="stone.visData"
                  label="Visual Spectrum Data (.txt)"
                  outlined
                  dense
                  :rules="[v => !!v || 'File is required']"
                  required
                ></v-file-input>
                <v-file-input
                  v-model="stone.pl633Data"
                  label="PL 633nm Data (.txt)"
                  outlined
                  dense
                  :rules="[v => !!v || 'File is required']"
                  required
                ></v-file-input>
                <v-file-input
                  v-model="stone.pl405Data"
                  label="PL 405nm Data (.txt)"
                  outlined
                  dense
                  :rules="[v => !!v || 'File is required']"
                  required
                ></v-file-input>

                <v-checkbox
                  v-model="stone.result.UVFlorescence"
                  color="indigo"
                  label="UV fluorescence"
                ></v-checkbox>
                <v-checkbox
                  v-model="stone.result.MidIRSpectrum"
                  color="indigo"
                  label="Mid Infra-red (IR) spectrum"
                ></v-checkbox>
                <v-checkbox
                  v-model="stone.result.PLSpectrum"
                  color="indigo"
                  label="Photo-luminescence (PL) spectrum"
                ></v-checkbox>
                <v-checkbox
                  v-model="stone.result.VisualCharacteristics"
                  color="indigo"
                  label="Visual characteristics"
                ></v-checkbox>
                <v-checkbox
                  v-model="stone.result.PhotochromicBehaviour"
                  color="indigo"
                  label="Photochromic behaviour"
                ></v-checkbox>
                <v-checkbox
                  v-model="stone.result.documentation"
                  color="indigo"
                  label="Documentation"
                ></v-checkbox>

                <!-- <v-btn type="submit" v-show="false">Create</v-btn> -->
              </v-form>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer />
              <v-btn color="indigo" @click="1" :disabled="!valid">Create</v-btn>
            </v-card-actions>-->
          </v-card>

          <v-btn
            :color="valid ? 'primary' : 'red darken-3'"
            @click="proceedIfValid"
            >Continue</v-btn
          >

          <v-btn text @click="step = 1">Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-step :complete="step > 2" step="2">Confirm</v-stepper-step>

        <v-stepper-content step="2">
          <v-card class="mb-12 elevation-0">
            <v-row>
              <v-col cols="6" sm="4" align="center">
                <v-card width="8rem">
                  <v-img
                    :src="imageData['Natural']"
                    height="8rem"
                    contain
                  ></v-img>
                  <v-card-subtitle>
                    <span>Visible</span>
                  </v-card-subtitle>
                </v-card>
              </v-col>

              <v-col cols="6" sm="4" align="center">
                <v-card width="8rem">
                  <v-img :src="imageData['365']" height="8rem" contain></v-img>
                  <v-card-subtitle>
                    <span>365nm</span>
                  </v-card-subtitle>
                </v-card>
              </v-col>

              <v-col cols="6" sm="4" align="center">
                <v-card width="8rem">
                  <v-img :src="imageData['255']" height="8rem" contain></v-img>
                  <v-card-subtitle>
                    <span>255nm</span>
                  </v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>

            <v-divider />

            <v-row align="center" justify="center">
              <svg
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                version="1.0"
                height="200pt"
                viewBox="0 0 1001.2268 503.16592"
                preserveAspectRatio="xMidYMid meet"
                id="svg1159"
                sodipodi:docname="diaIcon.svg"
                inkscape:version="0.92.4 5da689c313, 2019-01-14"
              >
                <metadata id="metadata1165">
                  <rdf:RDF>
                    <cc:Work rdf:about>
                      <dc:format>image/svg+xml</dc:format>
                      <dc:type
                        rdf:resource="http://purl.org/dc/dcmitype/StillImage"
                      />
                      <dc:title />
                    </cc:Work>
                  </rdf:RDF>
                </metadata>
                <defs id="defs1163">
                  <marker
                    inkscape:stockid="StopL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="marker2312"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      id="path2310"
                      d="M 0,5.65 V -5.65"
                      style="fill:none;fill-opacity:0.75;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(0.8)"
                      inkscape:connector-curvature="0"
                    />
                  </marker>
                  <marker
                    inkscape:stockid="StopL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="StopL"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      id="path2201"
                      d="M 0,5.65 V -5.65"
                      style="fill:none;fill-opacity:0.75;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(0.8)"
                      inkscape:connector-curvature="0"
                    />
                  </marker>
                  <marker
                    inkscape:stockid="TriangleInL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="TriangleInL"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      id="path2165"
                      d="M 5.77,0 -2.88,5 V -5 Z"
                      style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(-0.8)"
                      inkscape:connector-curvature="0"
                    />
                  </marker>
                  <marker
                    inkscape:stockid="StopL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="StopL-6"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      inkscape:connector-curvature="0"
                      id="path2201-4"
                      d="M 0,5.65 V -5.65"
                      style="fill:none;fill-opacity:0.75;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(0.8)"
                    />
                  </marker>
                  <marker
                    inkscape:stockid="StopL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="marker2312-9"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      inkscape:connector-curvature="0"
                      id="path2310-5"
                      d="M 0,5.65 V -5.65"
                      style="fill:none;fill-opacity:0.75;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(0.8)"
                    />
                  </marker>
                  <marker
                    inkscape:stockid="StopL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="StopL-1"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      inkscape:connector-curvature="0"
                      id="path2201-5"
                      d="M 0,5.65 V -5.65"
                      style="fill:none;fill-opacity:0.75;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(0.8)"
                    />
                  </marker>
                  <marker
                    inkscape:stockid="StopL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="marker2312-97"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      inkscape:connector-curvature="0"
                      id="path2310-7"
                      d="M 0,5.65 V -5.65"
                      style="fill:none;fill-opacity:0.75;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(0.8)"
                    />
                  </marker>
                  <marker
                    inkscape:stockid="StopL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="StopL-6-6"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      inkscape:connector-curvature="0"
                      id="path2201-4-7"
                      d="M 0,5.65 V -5.65"
                      style="fill:none;fill-opacity:0.75;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(0.8)"
                    />
                  </marker>
                  <marker
                    inkscape:stockid="StopL"
                    orient="auto"
                    refY="0"
                    refX="0"
                    id="marker2312-9-3"
                    style="overflow:visible"
                    inkscape:isstock="true"
                  >
                    <path
                      inkscape:connector-curvature="0"
                      id="path2310-5-6"
                      d="M 0,5.65 V -5.65"
                      style="fill:none;fill-opacity:0.75;fill-rule:evenodd;stroke:#000000;stroke-width:1.00000003pt;stroke-opacity:1"
                      transform="scale(0.8)"
                    />
                  </marker>
                </defs>
                <sodipodi:namedview
                  pagecolor="#ffffff"
                  borderColor="#666666"
                  borderopacity="1"
                  objecttolerance="10"
                  gridtolerance="10"
                  guidetolerance="10"
                  inkscape:pageopacity="0"
                  inkscape:pageshadow="2"
                  inkscape:window-width="2560"
                  inkscape:window-height="1338"
                  id="namedview1161"
                  showgrid="false"
                  inkscape:zoom="1.4203125"
                  inkscape:cx="448.12125"
                  inkscape:cy="234.96402"
                  inkscape:window-x="0"
                  inkscape:window-y="34"
                  inkscape:window-maximized="1"
                  inkscape:current-layer="svg1159"
                  fit-margin-top="0"
                  fit-margin-left="0"
                  fit-margin-right="0"
                  fit-margin-bottom="0"
                />
                <path
                  style="fill-opacity:1;stroke:none;stroke-width:0.75px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  :fill="stone.colour.hex ? stone.colour.hex : '#ffffff'"
                  d="m 176.98673,223.12363 85.13285,-76.1715 h 186.71416 l 85.13285,76.17149 -178.48026,203.12401 z"
                  id="path1165"
                  inkscape:connector-curvature="0"
                />
                <text
                  xml:space="preserve"
                  style="font-style:normal;font-weight:normal;font-size:42.16865158px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.05421638"
                  x="548.79022"
                  y="412.8237"
                  id="text2028"
                >
                  <tspan
                    sodipodi:role="line"
                    id="tspan2026"
                    x="548.79022"
                    y="412.8237"
                    style="stroke-width:1.05421638"
                  >
                    <tspan style="font-weight:bold" id="tspan1169">
                      {{ stone.weight }}
                    </tspan>
                    &nbsp;carats
                  </tspan>
                </text>
                <path
                  style="fill:none;stroke:#000000;stroke-width:2.64965224;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;marker-start:url(#StopL-1);marker-end:url(#marker2312-97);paint-order:markers stroke fill"
                  d="M 140.48498,429.78415 V 144.84816"
                  id="path2030"
                  inkscape:connector-curvature="0"
                />
                <path
                  style="fill:none;stroke:#000000;stroke-width:2.93500066;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;marker-start:url(#StopL-6-6);marker-end:url(#marker2312-9-3);paint-order:markers stroke fill"
                  d="M 174.21583,113.34287 H 523.82769"
                  id="path2030-0"
                  inkscape:connector-curvature="0"
                />
                <text
                  xml:space="preserve"
                  style="font-style:normal;font-weight:normal;font-size:42.16865158px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.05421638"
                  x="273.26962"
                  y="82.473785"
                  id="text2343"
                >
                  <tspan
                    sodipodi:role="line"
                    id="tspan2341"
                    x="273.26962"
                    y="82.473785"
                    style="stroke-width:1.05421638"
                  >
                    {{ stone.width }} mm
                  </tspan>
                </text>
                <text
                  xml:space="preserve"
                  style="font-style:normal;font-weight:normal;font-size:42.16865158px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.05421638"
                  x="-343.34656"
                  y="105.26173"
                  id="text2343-4"
                  transform="rotate(-90)"
                >
                  <tspan
                    sodipodi:role="line"
                    id="tspan2341-8"
                    x="-343.34656"
                    y="105.26173"
                    style="stroke-width:1.05421638"
                  >
                    {{ stone.depth }} mm
                  </tspan>
                </text>
                <text
                  xml:space="preserve"
                  style="font-style:normal;font-weight:normal;font-size:42.16865158px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.05421638"
                  x="549.14496"
                  y="366.06241"
                  id="text2365"
                >
                  <tspan
                    sodipodi:role="line"
                    id="tspan2363"
                    x="549.14496"
                    y="366.06241"
                    style="stroke-width:1.05421638"
                  >
                    <tspan style="font-style:italic" id="tspan1171">
                      {{ stone.shape }}
                    </tspan>
                    , {{ stone.colour.name ? stone.colour.name : stone.colour }}
                  </tspan>
                </text>
                <path
                  style="fill:none;stroke:#000000;stroke-width:5.25;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="m 355.28031,146.76544 -93.16073,0.18669 -85.13285,76.1715 178.10287,204.47753 178.87699,-204.47754 -85.13285,-76.17149 -93.55343,-0.18669"
                  id="path1168"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="ccccccc"
                />
                <path
                  style="fill:none;stroke:#000000;stroke-width:5.24999996;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none"
                  d="m 262.11958,146.95213 29.1244,75.42472 64.03633,-75.61141"
                  id="path1172"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="ccc"
                />
                <path
                  style="fill:none;stroke:#000000;stroke-width:5.24999996;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none"
                  d="M 355.46701,426.24764 291.24398,222.37685 176.98673,223.12363"
                  id="path1174"
                  inkscape:connector-curvature="0"
                />
                <path
                  style="fill:none;stroke:#000000;stroke-width:5.24999996;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none"
                  d="m 448.83374,146.95213 -29.12439,75.42471 -64.42904,-75.6114"
                  id="path1172-5"
                  inkscape:connector-curvature="0"
                  sodipodi:nodetypes="ccc"
                />
                <path
                  style="fill:none;stroke:#000000;stroke-width:5.24999996;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none"
                  d="m 355.48633,426.24763 64.22302,-203.87079 114.25724,0.74678"
                  id="path1174-0"
                  inkscape:connector-curvature="0"
                />
                <path
                  style="fill:none;stroke:#000000;stroke-width:5.24999996;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none"
                  d="m 291.24398,222.37685 128.46537,-1e-5"
                  id="path1201"
                  inkscape:connector-curvature="0"
                />
              </svg>
            </v-row>
          </v-card>

          <v-btn color="primary" @click="createCert">Confirm</v-btn>

          <v-btn text @click="step = 1">Back</v-btn>
        </v-stepper-content>

        <v-stepper-step step="3">Generate</v-stepper-step>

        <v-stepper-content step="3">
          <v-row align="center" justify="center">
            <v-card
              class="mx-auto mb-2"
              :loading="
                ['nascent', 'compiling', 'halfway'].includes(cert.status)
                  ? cert.status !== 'nascent'
                    ? 'green'
                    : 'amber'
                  : false
              "
            >
              <v-card-title>Report No. {{ cert.id }}</v-card-title>
              <v-card-text>
                <div class="text-center" v-if="cert.status === 'nascent'">
                  <v-progress-circular
                    indeterminate
                    color="amber"
                  ></v-progress-circular
                  >&emsp;
                  <span class="amber--text">Creating</span>
                </div>
                <div
                  class="text-center"
                  v-if="
                    [
                      'plotting',
                      'compiling-digital',
                      'preview-digital',
                      'compiling-print',
                      'preview-print'
                    ].includes(cert.status)
                  "
                >
                  <v-progress-linear
                    color="blue"
                    height="6"
                    rounded
                    class="mb-2"
                    :value="
                      (100 / 6) *
                        (1 +
                          [
                            'plotting',
                            'compiling-digital',
                            'preview-digital',
                            'compiling-print',
                            'preview-print'
                          ].indexOf(cert.status))
                    "
                  ></v-progress-linear>
                  <span class="blue--text text--darken-2">
                    {{ this.cert.status.replace(/(\w+)-(\w+)/, "$1 ($2)") }}
                  </span>
                </div>
                <div class="text-center" v-if="cert.status === 'error'">
                  <v-alert type="error" text max-width="40rem">
                    <div class="title">Error during {{ this.cert.error }}</div>
                    <pre style="white-space: pre-wrap;"
                      >{{ this.cert.message }}
                      </pre
                    >
                  </v-alert>
                </div>
                <div class="text-center" v-if="cert.status === 'created'">
                  <v-container fluid>
                    <v-row dense>
                      <v-col>
                        <v-img
                          contain
                          :src="
                            'https://reports.deltadiamondlab.com/' +
                              cert.id +
                              '/' +
                              cert.id +
                              '-preview.jpg'
                          "
                          @click.stop="expand.cert_d = true"
                        ></v-img>
                        <v-dialog v-model="expand.cert_d" max-width="65vw">
                          <v-img
                            :src="
                              'https://reports.deltadiamondlab.com/' +
                                cert.id +
                                '/' +
                                cert.id +
                                '.jpg'
                            "
                            contain
                          ></v-img>
                        </v-dialog>

                        <v-chip
                          link
                          :href="
                            'https://reports.deltadiamondlab.com/' + cert.id
                          "
                          target="_blank"
                          outlined
                          pill
                          class="ma-2"
                          color="blue"
                        >
                          <v-avatar left color="blue">
                            <v-icon color="white"
                              >mdi-link-variant</v-icon
                            > </v-avatar
                          >Online Report
                        </v-chip>
                      </v-col>

                      <v-col>
                        <v-img
                          contain
                          :src="
                            'https://reports.deltadiamondlab.com/' +
                              cert.id +
                              '/' +
                              cert.id +
                              '-print-preview.jpg'
                          "
                          @click.stop="expand.cert_p = true"
                        ></v-img>
                        <v-dialog v-model="expand.cert_p" max-width="65vw">
                          <v-img
                            :src="
                              'https://reports.deltadiamondlab.com/' +
                                cert.id +
                                '/' +
                                cert.id +
                                '-print.jpg'
                            "
                            contain
                          ></v-img>
                        </v-dialog>

                        <v-chip
                          link
                          :href="
                            'https://reports.deltadiamondlab.com/' +
                              cert.id +
                              '/' +
                              cert.id +
                              '-print.pdf'
                          "
                          target="_blank"
                          outlined
                          pill
                          class="ma-2"
                          color="blue"
                        >
                          <v-avatar left color="blue">
                            <v-icon color="white"
                              >mdi-link-variant</v-icon
                            > </v-avatar
                          >Print Version
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </v-card-text>
              <br />
            </v-card>
          </v-row>

          <v-btn
            color="primary"
            route
            to="/home"
            :disabled="!['created', 'error'].includes(this.cert.status)"
            >Done</v-btn
          >
          &nbsp;
          <v-btn v-if="cert.status === 'error'" text @click="deleteCert"
            >Edit and retry</v-btn
          >
          <v-btn
            v-if="cert.status === 'created'"
            text
            @click="deletion.recreateDialouge = true"
            >Delete and recreate</v-btn
          >
          <v-dialog v-model="deletion.recreateDialouge" max-width="290">
            <v-card :loading="deletion.executing ? 'red' : false">
              <v-card-title class="headline">Delete certificate?</v-card-title>

              <v-card-text>
                Irrevocably delete this certificate, and return to the first
                stage, retaining all information provided.
                <div class="text-center" v-if="deletion.error">
                  <v-alert type="error" text>
                    <div class="title">Error</div>
                    <pre style="white-space: pre-wrap;"
                      >{{ this.deletion.message }}
                      </pre
                    >
                  </v-alert>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="grey darken-1"
                  text
                  @click="deletion.recreateDialouge = false"
                >
                  Cancel
                </v-btn>

                <v-btn color="red darken-1" text @click="deleteCert">
                  {{ this.deletion.actionText }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-stepper-content>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
import session from "../api/session";
export default {
  name: "create",
  data() {
    return {
      valid: true,
      stone: {
        customer: "",
        weight: "",
        colour: "",
        shape: "",
        width: "",
        depth: "",
        inscription: "",
        remarks: "",
        imageNatural: null,
        image365: null,
        image255: null,
        ftirData: null,
        pl633Data: null,
        pl405Data: null,
        visData: null,
        result: {
          UVFlorescence: false,
          MidIRSpectrum: false,
          PLSpectrum: false,
          VisualCharacteristics: false,
          PhotochromicBehaviour: false,
          documentation: false
        }
      },
      imageData: {
        "365": "",
        "255": "",
        Natural: ""
      },
      stoneShapes: [
        "Round",
        "Princess",
        "Cushion",
        "Oval",
        "Emerald",
        "Pear",
        "Asscher",
        "Heart",
        "Radiant",
        "Marquise"
      ],
      stoneColours: [
        { name: "Purple", hex: "#de50eb" },
        { name: "Purplish Pink", hex: "#eb50c4" },
        { name: "Pink", hex: "#f07fb9" },
        { name: "Brownish Pink", hex: "#f0817f" },
        { name: "Pinkish Brown", hex: "#f09b7f" },
        { name: "Brown", hex: "#dea376" },
        { name: "Orange", hex: "#fcba03" },
        { name: "Orangy Yellow", hex: "#fcd303" },
        { name: "Yellow", hex: "#fcf403" },
        { name: "Blue", hex: "#768ff5" },
        { name: "Violet", hex: "#9876f5" },
        { name: "Colourless", hex: "#ffffff" },
        { name: "Green", hex: "#c4f590" }
      ],
      customers: [],
      cert: {
        id: "?",
        status: "", // as "" | "nascent" | "plotting" | "compiling-digital" | "preview-digital" | "compiling-pring" | "preview-print" | "created" | "error",
        error: "",
        message: ""
      },
      step: 1,
      deletion: {
        recreateDialouge: false,
        error: false,
        message: "",
        executing: false,
        actionText: "Delete"
      },
      expand: {
        cert_d: false,
        cert_p: false
      }
    };
  },
  methods: {
    onFileInput(event, item) {
      const data = URL.createObjectURL(event);
      this.imageData[item] = data;
    },
    proceedIfValid() {
      if (this.$refs.form.validate()) {
        this.step = 2;
      }
    },
    createCert() {
      // clear out any old data
      this.cert = { id: "?", status: "", error: "", message: "" };
      let formData = new FormData();
      for (var key in this.stone) {
        if (key === "colour") {
          formData.append(
            "colour",
            this.stone["colour"].name
              ? this.stone["colour"].name
              : this.stone["colour"]
          );
        } else if (
          typeof this.stone[key] === "object" &&
          Object.keys(this.stone[key]).length > 0
        ) {
          for (var subKey in this.stone[key]) {
            formData.append(`${key}.${subKey}`, this.stone[key][subKey]);
          }
        } else {
          formData.append(key, this.stone[key]);
        }
      }
      session
        .post("/api/cert/create/", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          response => {
            this.cert.id = response.data.uid;
            this.certStatus();
          },
          failiure => {
            this.cert.status = "error";
            this.cert.error = "server request";
            this.cert.message = failiure.response.data
              .split("Request Method: POST")[0]
              .trim()
              .replace(/\n/g, " ")
              .replace(/BusyError at \/api\/cert\/create\/ ?/, "");
          }
        );
      this.step = 3;
    },
    certStatus() {
      if (!["created", "error"].includes(this.cert.status)) {
        session.get(`/api/cert/status?id=${this.cert.id}`).then(
          response => {
            if (response.data == "error") {
              this.cert.error = this.cert.status;
            }
            this.cert.status = response.data;
            setTimeout(() => {
              this.certStatus();
            }, 400);
          },
          failiure => {
            setTimeout(() => {
              this.certStatus();
            }, 400);
          }
        );
      }
      if (this.cert.status == "error") {
        session.get(`/api/cert/errorInfo?id=${this.cert.id}`).then(request => {
          const errorLines = request.data.replace(/\n$/, "").split("\n");
          this.cert.message = errorLines[errorLines.length - 1];
        });
      }
    },
    deleteCert() {
      if (this.deletion.error) {
        this.deletion.error = false;
        this.deletion.message = "";
        this.deletion.actionText = "Delete";
        return;
      }
      this.deletion.executing = true;
      session.get(`/api/cert/delete?id=${this.cert.id}`).then(
        response => {
          this.deletion.executing = false;
          this.deletion.recreateDialouge = false;
          this.step = 1;
        },
        failiure => {
          this.deletion.executing = false;
          this.deletion.error = true;
          this.deletion.actionText = "Close";
          this.deletion.message = failiure.response.data
            .split("Request Method: GET")[0]
            .replace(/\n/g, " ")
            .trim();
        }
      );
    }
  },
  created() {
    session.get("/api/cert/customers/").then(request => {
      this.customers = request.data;
    });
  }
};
</script>
